import EmptyStateModal from './EmptyStateModal';

export default EmptyStateModal;
